import classNames from 'classnames';
import RichText from '@/components/atoms/rich-text/rich-text';
import SkeletonLoader from '@/components/atoms/skeleton-loader/skeleton-loader';
import Typography from '@/components/atoms/typography/typography';
import Container from '@/components/utilities/container/container';
import styles from './onboarding-flow-step-header-module.module.scss';

type OnboardingFlowStepHeaderModuleContentProps = Omit<
  Content.Components['OnboardingFlowStepHeaderModuleDto'],
  '$type' | 'id' | 'pageId' | 'settings'
>;

export type OnboardingFlowStepHeaderModuleProps =
  | ({
      /** The class name to apply */
      className?: string;
      /** Indicates whether to display loading state */
      isLoading: true;
    } & Partial<OnboardingFlowStepHeaderModuleContentProps>)
  | ({
      /** The class name to apply */
      className?: string;
      /** Indicates whether to display loading state */
      isLoading?: false;
    } & OnboardingFlowStepHeaderModuleContentProps);

const OnboardingFlowStepHeaderModule = ({
  className,
  description,
  headline,
  isLoading = false,
}: OnboardingFlowStepHeaderModuleProps) => {
  if (isLoading) {
    return (
      <div className={classNames(styles.component, className)}>
        <Container className={styles.container}>
          <SkeletonLoader
            borderRadius="4px"
            className={styles.headline}
            height="34px"
            width="60%"
          />

          <SkeletonLoader
            borderRadius="4px"
            className={styles.description}
            height="16px"
            width="100%"
          />

          <SkeletonLoader
            borderRadius="4px"
            className={styles.description}
            height="16px"
            width="90%"
          />
        </Container>
      </div>
    );
  }

  return (
    <div className={classNames(styles.component, className)}>
      <Container className={styles.container}>
        {headline && (
          <Typography className={styles.headline} tagStyle="headingMedium">
            {headline}
          </Typography>
        )}

        {description && (
          <RichText className={styles.description} text={description} />
        )}
      </Container>
    </div>
  );
};

OnboardingFlowStepHeaderModule.displayName = 'OnboardingFlowStepHeaderModule';

export default OnboardingFlowStepHeaderModule;
